export const getErrorString = (reason: any, custom: string = 'An error has occured.') => {
    if (typeof(reason) === 'string') {
        return reason;
    } else if (typeof(reason) === 'object') {
        return reason.message;
    } else {
        return custom;
    }
}